import React from "react";
import {FlexCol, FlexRow} from "../generic/Containers";
import {BCHeader4} from "../generic/BCHeaders";
// import AirbnbLogo from "../../images/experience/airbnb.svg";
import LinkedInLogo from "../../images/experience/linkedin.svg";
import DeltaLogo from "../../images/experience/delta.svg";
import HomeDepotLogo from "../../images/experience/home-depot.svg";
import StartUpsLogo from "../../images/experience/start-ups.svg";
import BrightwellLogo from "../../images/experience/brightwell.svg";
import DvidsLogo from "../../images/experience/dvids.svg";


const experienceItems: Array<{ label: string; img: string, height: number }> = [
    // {label: 'Airbnb', img: AirbnbLogo, height: 40},
    {label: 'LinkedIn', img: LinkedInLogo, height: 36},
    {label: 'Delta', img: DeltaLogo, height: 28},
    {label: 'Home Depot', img: HomeDepotLogo, height: 40},
    {label: 'Start Ups', img: StartUpsLogo, height: 38},
    {label: 'Brightwell', img: BrightwellLogo, height: 30},
    {label: 'Dvids', img: DvidsLogo, height: 25},
];

export const FounderCompaniesComponent: React.FC = () => {
    const duplicatedItems = [...experienceItems, ...experienceItems];
    
    return (
        <FlexCol
            widthPercent={100}
            align="center"
            padding={1}
            style={{
                position: 'relative',
            }}
        >
            <BCHeader4 className={'founder-subheader'} fontWeight={"normal"} text={"Created by a self-taught dev who has worked all across the industry"}/>
            <div className={'founder-companies-container'} style={{
                position: 'relative',
                width: '100%',
                overflow: 'hidden',
                padding: '2em 0',
            }}>
                <div style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: '100px',
                    background: 'linear-gradient(to right, white 0%, transparent 100%)',
                    zIndex: 2,
                    pointerEvents: 'none',
                }} />
                <div style={{
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    width: '100px',
                    background: 'linear-gradient(to left, white 0%, transparent 100%)',
                    zIndex: 2,
                    pointerEvents: 'none',
                }} />
                <FlexRow 
                    gap={3} 
                    align="center"
                    className="logo-carousel"
                    style={{
                        animation: 'scroll 30s linear infinite',
                        width: 'max-content',
                    }}
                >
                    {duplicatedItems.map((item, index) => (
                        <img
                            key={index}
                            src={item.img}
                            alt={`${item.label} logo`}
                            style={{
                                width: 'auto', 
                                height: `${item.height}px`, 
                                objectFit: 'contain',
                                flexShrink: 0,
                            }}
                        />
                    ))}
                </FlexRow>
            </div>
            <style>{`
                @keyframes scroll {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-50%);
                    }
                }
                .logo-carousel:hover {
                    animation-play-state: paused;
                }
            `}</style>
        </FlexCol>
    )
}
